import transform from 'lodash/transform';
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';
import isEmpty from 'lodash/isEmpty';
import isDate from 'lodash/isDate';
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

const isNullBlankOrUndefined = function (value) {
    return typeof value === 'undefined' || value == null || value === '';
};

const objectUtils = {
    difference: (object, base, ignoreBlanks = false) => {
        const diff = transform(object, (result, value, key) => {
            if (isDate(value) && isDate(base[key]) && value.getTime() === base[key].getTime()) {
                return;
            }
            if (!isEqual(value, base[key])) {
                if (
                    ignoreBlanks &&
                    isNullBlankOrUndefined(value) &&
                    isNullBlankOrUndefined(base[key])
                )
                    return;
                result[key] =
                    isObject(value) && isObject(base[key])
                        ? objectUtils.difference(value, base[key])
                        : value;
            }
        });

        return isEmpty(diff) ? null : diff;
    },

    /**
   * Generates a sequence of merged objects by combining a base object
   * with each object in the provided overrides array.
   *
   * Each override is deep-cloned and merged with a deep-cloned `baseObject`.
   * This avoids mutation and ensures clean, independent merged results.
   *
   * @generator
   * @function generateObjects
   * @memberof objectUtils
   * @param {Object} baseObject - The template object to merge with each override.
   * @param {Array<Object>} overridesArray - An array of objects to merge into the base object.
   * @yields {Object} A new object representing the merged result of `baseObject` and an override.
   *
   **/

    generateObjects: function* (baseObject, overridesArray) {
        for (const item of overridesArray) {
            yield merge(cloneDeep(baseObject), cloneDeep(item))
        }
    }
};

export default objectUtils;
